var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailDraft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "email-draft_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#email-draft_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.5 20.5v-1.433l5.146-5.146 1.433 1.433-5.146 5.146zm-9-5v-1h7v1zm16.279-.846-1.433-1.433.725-.725a.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l.725.725a.5.5 0 0 1 .16.354.5.5 0 0 1-.16.354zM3.5 11.5v-1h11v1zm0-4v-1h11v1z"
}))));
export default SvgEmailDraft;